import CONFIG from '../config/config';
import type { BookingConfirmationEmailConfig } from '../pages/SettingsPage/reminders/BookingConfirmationEmail/BookingConfirmationEmail';
import type { BrandIntroReminderConfig } from '../pages/SettingsPage/reminders/BrandIntroReminder/BrandIntroReminder';
import type { PostVisitEmailConfig } from '../pages/SettingsPage/reminders/PostVisitEmail/PostVisitEmail';
import type {
  VisitReminderConfig,
  WeddingRateConfig,
} from '../pages/SettingsPage/sections/NotificationsSegment';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export type Reminders = {
  smsReminder?: VisitReminderConfig;
  weddingRateReminder?: WeddingRateConfig;
  brandIntroReminder?: BrandIntroReminderConfig;
  postVisitEmail?: PostVisitEmailConfig;
  bookingConfirmationEmail?: BookingConfirmationEmailConfig;
};

export type NotificationTestEmailPayload = {
  subject: string;
  htmlBody: string;
  textBody?: string;
  /** "plain" | "html"; omit → plain (legacy). When plain, htmlBody is plain text. */
  emailBodyFormat?: "plain" | "html";
};

const RemindersAPI = {
  get: () => APIClient(CONFIG.API_ENDPOINT).get<Reminders>(`v1/configuration/notifications`),
  update: (reminders: Reminders) => APIClient(CONFIG.API_ENDPOINT).put<Reminders>(`v1/configuration/notifications`, reminders),
  sendTestEmail: (payload: NotificationTestEmailPayload) =>
    APIClient(CONFIG.API_ENDPOINT).post<{ status: string }>(`v1/configuration/notifications/test-email`, payload),
};

export default RemindersAPI;
